import client from './client'
import type { UserPhoneNumber } from '../types'

export async function addPhoneNumber(number: string, label: string): Promise<UserPhoneNumber> {
  const { data } = await client.post<UserPhoneNumber>('/api/v1/notifications/phones', { number, label })
  return data
}

export async function verifyPhoneNumber(number: string, code: string): Promise<UserPhoneNumber[]> {
  const { data } = await client.post<UserPhoneNumber[]>(
    `/api/v1/notifications/phones/${encodeURIComponent(number)}/verify`,
    { code }
  )
  return data
}

export async function resendPhoneCode(number: string): Promise<UserPhoneNumber[]> {
  const { data } = await client.post<UserPhoneNumber[]>(
    `/api/v1/notifications/phones/${encodeURIComponent(number)}/resend`
  )
  return data
}

export async function deletePhoneNumber(number: string): Promise<void> {
  await client.delete(`/api/v1/notifications/phones/${encodeURIComponent(number)}`)
}
